(() => {
  const initialized = new WeakSet();

  function init(root) {
    if (!root || initialized.has(root)) return;
    const bar = root.querySelector('[data-creditex-sticky-atc]');
    if (!bar) return;
    initialized.add(root);

    const stickyButton = bar.querySelector('[data-sticky-submit]');
    const stickyLabel = bar.querySelector('[data-sticky-label]');
    const stickySelection = bar.querySelector('[data-sticky-selection]');
    const stickyPrice = bar.querySelector('[data-sticky-price]');
    const mobile = matchMedia('(max-width: 749px)');
    let watchedButton;
    let buttonObserver;
    let dismissed = false;

    function setVisible(visible) {
      const show = visible && !dismissed && mobile.matches && root.isConnected;
      if (bar.classList.contains('is-visible') !== show) bar.classList.toggle('is-visible', show);
      if (document.body.classList.contains('creditex-has-sticky-atc') !== show) {
        document.body.classList.toggle('creditex-has-sticky-atc', show);
      }
    }

    function sync() {
      const addButton = root.querySelector('.product-form__submit');
      const variant = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const pending = !!addButton?.classList.contains('loading');
      const unavailable = !variant?.value || !addButton || addButton.disabled
        || addButton.getAttribute('aria-disabled') === 'true';
      const label = pending ? 'Agregando…' : unavailable ? 'Elegir talla' : 'Agregar al carrito';
      if (stickyLabel.textContent !== label) stickyLabel.textContent = label;
      stickyButton.disabled = pending;
      stickyButton.setAttribute('aria-busy', String(pending));
      const size = root.querySelector('variant-selects [data-creditex-option="talla"] input:checked')
        || root.querySelector('variant-selects [data-creditex-option="size"] input:checked');
      const selection = size ? `Talla ${size.value}` : 'Talla elegida';
      if (stickySelection.textContent !== selection) stickySelection.textContent = selection;
      const price = root.querySelector('[id^="price-"]');
      const currentPrice = price?.querySelector('.price--on-sale .price__sale .price-item--sale')
        || price?.querySelector('.price__regular .price-item--regular');
      if (currentPrice && stickyPrice.textContent.trim() !== currentPrice.textContent.trim()) {
        stickyPrice.textContent = currentPrice.textContent.trim();
      }
      if (addButton !== watchedButton) {
        buttonObserver?.disconnect();
        watchedButton = addButton;
        if (addButton) {
          buttonObserver = new IntersectionObserver(([entry]) => {
            // Mostrarla únicamente después de pasar los controles de compra.
            setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
          });
          buttonObserver.observe(addButton);
        } else setVisible(false);
      }
      if (!mobile.matches || dismissed) setVisible(false);
    }

    stickyButton.addEventListener('click', () => {
      sync();
      if (stickyButton.disabled) return;
      const addButton = root.querySelector('.product-form__submit');
      const variant = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (!variant?.value || !addButton || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') {
        const picker = root.querySelector('variant-selects');
        picker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker?.querySelector('input:not(.disabled), select')?.focus({ preventScroll: true });
        return;
      }
      // Usa el formulario del producto: variante elegida, carga, errores y apertura del carrito.
      addButton.click();
    });
    bar.querySelector('[data-sticky-close]')?.addEventListener('click', () => {
      dismissed = true;
      setVisible(false);
    });

    root.querySelectorAll('[data-creditex-coupon]').forEach(coupon => {
      const button = coupon.querySelector('[data-creditex-coupon-buy]');
      const label = button?.querySelector('[data-creditex-coupon-label]');
      const status = coupon.querySelector('[data-creditex-coupon-status]');
      button?.addEventListener('click', async () => {
        if (button.disabled) return;
        const code = button.dataset.creditexCouponCode?.trim();
        const form = root.querySelector('form[data-type="add-to-cart-form"]');
        const variantId = form?.querySelector('input[name="id"]')?.value;
        const mainButton = root.querySelector('.product-form__submit');
        if (!code || !variantId || mainButton?.disabled) {
          if (status) status.textContent = 'Selecciona una talla disponible para continuar.';
          return;
        }

        const quantityInput = root.querySelector('.product-form__quantity .quantity__input');
        const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
        const base = window.Shopify?.routes?.root || '/';
        try { sessionStorage.setItem('creditex_coupon', code.toUpperCase()); } catch (_) {}
        button.disabled = true;
        if (label) label.textContent = 'Agregando…';

        // Agregar la variante y aplicar el código al carrito nativo de Shopify.
        try {
          const added = await fetch(base + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
          });
          if (!added.ok) {
            const error = await added.json();
            throw new Error(error.description || 'No se pudo agregar la talla elegida.');
          }
          try {
            await fetch(base + 'cart/update.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ discount: code })
            });
          } catch (_) { /* El campo sigue disponible en el precheckout. */ }
          window.location.href = base + 'pages/cart';
        } catch (error) {
          if (status) status.textContent = error.message || 'Intenta nuevamente.';
          button.disabled = false;
          if (label) label.textContent = 'Comprar con cupón';
        }
      });
      window.addEventListener('pageshow', () => {
        if (button) button.disabled = false;
        if (label) label.textContent = 'Comprar con cupón';
      });
    });

    new MutationObserver(records => {
      if (records.some(record => !bar.contains(record.target))) sync();
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value', 'class'] });
    mobile.addEventListener('change', () => {
      sync();
      const bounds = watchedButton?.getBoundingClientRect();
      setVisible(!!bounds && bounds.bottom <= 0);
    });
    sync();
  }

  document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(init);
  document.addEventListener('product-info:loaded', event => init(event.target));
})();
